import { ComponentProps } from "react";
import { Field, FieldError } from "../ui/field";

export type FieldProps = {
  label?: string;
  description?: string;
  errors?: string[];
  fieldProps?: ComponentProps<typeof Field>;
};

export function FieldErrors({ errors }: { errors?: string[] }) {
  if (!errors) {
    return null;
  }

  return (
    <>
      {errors.map((errMsg) => (
        <FieldError key={errMsg}>{errMsg}</FieldError>
      ))}
    </>
  );
}

export type DebounceProps = {
  /**
   * Whether keystrokes are buffered and reported once the user pauses.
   * Defaults to true — see {@link InputDebounced} for why.
   *
   * Set to false when the caller needs every keystroke as it happens: live
   * validation, a character counter, search-as-you-type.
   */
  debounce?: boolean;
  /** Debounce delay in milliseconds. Ignored when `debounce` is false. */
  delay?: number;
};
